// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__367cc","inputWrap":"styles_inputWrap__2xvGO","input":"styles_input__2Ros4"};